{
    "general": {
        "custom_text": {
            "login": "Accédez ",
            "contact_us": "Contactez-nous",
            "show_more_collection": "afficher les catégories",
            "hide_collection": "masquer les catégories",
            "show_more_specification": "toutes les fonctionnalités",
            "hide_specification": "cacher",
            "product": "produit",
            "products": "Produits",
            "new_product": "New",
            "login_page": {
                "remember_me": "Souviens-toi de moi"
            },
            "signup_page": {
                "company": "Entreprise",
                "signup_failed": "Demande d'inscription échouée, veuillez réessayer plus tard ou contacter le service client.",
                "signup_success": "Demande d'inscription envoyée, vous serez recontacté pour confirmer vos informations.",
                "account_area_disclaimer": "L’espace réservé sera bientôt disponible.",
                "role_options": "Client, Agent, Compte tiers",
                "sector_options": "Revente, Production, Construction"
            },
            "specifications_product": {
                "family": "Famille",
                "step": "Pas",
                "din": "DIN",
                "degree": "Degré",
                "uni": "UNI",
                "iso": "ISO",
                "class": "Classe",
                "finishing": "Finition",
                "brand": "Marca",
                "clothesColor": "Couleur",
                "clothesMeasure": "Couper",
                "color": "Couleur",
                "hardness": "Dureté",
                "endurance": "Résistance",
                "material": "Matériau",
                "Antivibranti_Corpo": "Matériel corps",
                "Antivibranti_TempEsercizio": "Température d’exercice",
                "Antivibranti_Colore": "",
                "Antivibranti_Materiale": "",
                "Antivibranti_Note": "Remarques",
                "Antivibranti_Base": "Matériel embase",
                "Antivibranti_Campana": "Matériel cloche",
                "Antivibranti_Perno": "Matériel tige",
                "Antivibranti_Boccola": "Matériel douille",
                "Antivibranti_Rondella": "Matériel rondelle",
                "Antivibranti_DurezzaGomma": "Dureté du caoutchouc",
                "Antivibranti_Din": "Norme",
                "Antivibranti_Norma": "Norme",
                "Pressacavi_Corpo": "",
                "Pressacavi_Inserto": "Matériel insert",
                "Pressacavi_Colore": "",
                "Pressacavi_Autoestinguenza": "Autoextinguibilité",
                "Pressacavi_AnelloTenuta": "Matériel bague d’étanchéité",
                "Pressacavi_Oring": "",
                "Pressacavi_MaterialeGuarnizione": "Matériel joint",
                "Pressacavi_Molla": "Matériel ressort",
                "Pressacavi_TemperaturaEsercizio": "Température d’exercice",
                "Pressacavi_Accessori": "",
                "Pressacavi_Note": "Remarques",
                "Pressacavi_AnelloTenutaInterno": "Matériel bague d’étanchéité intérieure",
                "Pressacavi_AnelloTenutaEsterno": "Matériel bague d’étanchéité extérieure",
                "Pressacavi_GradoProtezione": "Indice de protection",
                "Pressacavi_Membrana": "Matériel membrane",
                "Pressacavi_Guarnizione": "",
                "Pressacavi_PassaggioAria": "Passage de l’air",
                "Pressacavi_PassaggioAcqua": "Passage de l’eau",
                "Pressacavi_Impiego": "Utilisation",
                "Pressacavi_Materiale": "Matériel",
                "Pressacavi_MaterialeCorpo": "Matériel corps",
                "Pressacavi_MaterialeOring": "Matériel O-ring",
                "Pressacavi_TrattamentoSuperficiale": "",
                "Pressacavi_TrattamentoSuperficialeCorpo": "",
                "Pressacavi_TestStandard": "Test standard",
                "Pressacavi_UlCsaFile": "Ul/Csa-File",
                "Pressacavi_Certificazione": "Certification",
                "Fascette_Autoestinguenza": "Autoextinguibilité",
                "Fascette_TempEsercizio": "Température d’exercice",
                "Fascette_Adesivo": "Adhésif",
                "Fascette_Norma": "Norme",
                "Fascette_Certificazione": "Certification",
                "Fascette_MaterialeCorpo": "Matériel corps",
                "Fascette_MaterialeGanascia": "Matériel mâchoire",
                "Fascette_Materiale": "Matériel",
                "Piedini_Certificazione": "Certification",
                "Piedini_Colore": "",
                "Piedini_Note": "Remarques",
                "Piedini_Accessori": "Accessoires",
                "Piedini_TrattamentoSuperficiale": "",
                "Piedini_MaterialePerno": "Matériel tige",
                "Piedini_TrattamentoSuperficialePerno": "",
                "Piedini_Materiale": "Matériel",
                "Piedini_MaterialeBase": "Matériel embase",
                "Piedini_ColoreBase": "",
                "Piedini_TrattamentoSuperficialeBase": "",
                "Piedini_TrattamentoSuperficialeDado": "",
                "Piedini_MaterialeAntiscivolo": "Matériel antidérapante",
                "Piedini_ColoreAntiscivolo": "",
                "Piedini_MaterialeDado": "Matériel écrou",
                "FissaggioCavi_Norma": "Norme",
                "FissaggioCavi_Certificazione": "Certification",
                "FissaggioCavi_Autoestinguenza": "Autoextinguibilité",
                "FissaggioCavi_Colore": "",
                "FissaggioCavi_Adesivo": "Adhésif",
                "FissaggioCavi_Note": "Remarques",
                "FissaggioCavi_Materiale": "Matériel",
                "Maniglie_CapacitaCarico": "Capacité de charge",
                "Maniglie_TempEsercizio": "Température d’exercice",
                "Maniglie_Colore": "",
                "Maniglie_Note": "Remarques",
                "Maniglie_Dimensioni": "",
                "Maniglie_Finitura": "",
                "Maniglie_Materiale": "Matériel",
                "Maniglie_FInituraSuperficiale": "",
                "Maniglie_MaterialeImpugnatura": "Matériel manette",
                "Maniglie_CoperturaImpugnatura": "",
                "Maniglie_TrattamentoSuperficialeImpugnatura": "",
                "Maniglie_FinituraSuperficialeImpugnatura": "",
                "Maniglie_MaterialeTappoCoperturaImpugnatura": "Matériel embout traverse",
                "Maniglie_MaterialeBoccola": "Matériel douille",
                "Maniglie_TrattamentoSuperficialeBoccola": "",
                "Maniglie_MaterialePerno": "Matériel tige",
                "Maniglie_TrattamentoSuperficialePerno": "",
                "Maniglie_MaterialeRondella": "Matériel rondelle",
                "Maniglie_MaterialePressioneRondella": "Matériel rondelle de pression",
                "Maniglie_TrattamentoSuperficialeRondella": "",
                "Maniglie_MaterialePulsante": "Matériel bouton",
                "Maniglie_MaterialeInserto": "Matériel insert",
                "Maniglie_MaterialeSupporto": "Matériel supports",
                "Maniglie_FinituraSuperficialeSupporto": "",
                "Maniglie_MaterialeTappoCoperturaSupporto": "Matériel embout supports",
                "Cerniere_MaterialeBaseSupportoSpina": "Matériel base, support et axe",
                "Cerniere_MaterialeBase": "",
                "Cerniere_Tipo": "",
                "Cerniere_Versione": "",
                "Cerniere_Colore": "",
                "Cerniere_Note": "Remarques",
                "Cerniere_TrattamentoSuperficialeBase": "",
                "Cerniere_MaterialeCorpo": "Matériel corps",
                "Cerniere_FinituraSuperficialeSupporto": "",
                "Cerniere_MaterialeCoperchio": "",
                "Cerniere_MaterialeSfere": "Matériel sphère",
                "Cerniere_MaterialeRondella": "Matériel rondelle",
                "Cerniere_MaterialeBoccolaPosizione": "Matériel bague d’indexage",
                "Cerniere_MaterialeRondellaAntifrizionamento": "Matériel rondelle anti-grippage",
                "Cerniere_MaterialeRondellaAntigrippaggio": "Matériel rondelle anti-grippage",
                "Cerniere_MaterialePerniFilettati": "",
                "Cerniere_TrattamentoSuperficialePerniFilettati": "",
                "Cerniere_MaterialeFlange": "Matériel platine",
                "Cerniere_FinituraSuperficialeFlange": "",
                "Cerniere_TrattamentoSuperficialeFlange": "",
                "Cerniere_MaterialeSpina": "Matériel axe",
                "Cerniere_FinituraSuperficialeSpina": "",
                "Cerniere_TrattamentoSuperficialeSpina": "",
                "Cerniere_MaterialeSeeger": "Matériel seeger",
                "Cerniere_TrattamentoSuperficialeSeegers": "",
                "Cerniere_MaterialePerno": "Matériel goujons",
                "Cerniere_TrattamentoSuperficialePerno": "",
                "Cerniere_MaterialeVite": "Matériel vis",
                "Cerniere_MaterialeDado": "Matériel écrou",
                "Cerniere_TrattamentoSuperficialeDado": "",
                "Cerniere_MaterialeMolla": "Matériel ressort",
                "Cerniere_TrattamentoSuperficialeMolla": "",
                "Cerniere_MaterialeSpinaArresto": "Matériel axe d’arrêt",
                "Cerniere_TrattamentoSuperficialeSpinaArresto": "",
                "Cerniere_MaterialePernoAllogiamento": "Matériel goujon",
                "Cerniere_TrattamentoSuperficialePernoAllogiamento": "",
                "Ruote_MaterialeAnello": "Matériel bandage",
                "Ruote_MaterialeNucleo": "Matériel corps de roue",
                "Ruote_MaterialeParafilo": "Matériel pare-fils",
                "Ruote_TempEsercizio": "Température d’exercice",
                "Ruote_Mozzo": "Moyeu",
                "Ruote_VelocitaLavoro": "Vitesse de travail",
                "Ruote_Note": "Remarques",
                "Ruote_Impiego": "Utilisation",
                "Ruote_Accessori": "Accessoires",
                "Ruote_MaterialeRuota": "Matériel roulette",
                "Ruote_MaterialeSupporto": "Matériel supports",
                "Ruote_Materiale": "",
                "Pomelli_ColoreImpugnatura": "",
                "Pomelli_ColoreTappo": "",
                "Pomelli_Colore": "",
                "Pomelli_Finitura": "",
                "Pomelli_Note": "Remarques",
                "Pomelli_MaterialeImpugnatura": "Matériel manette",
                "Pomelli_Materiale": "",
                "Pomelli_FinituraImpugnatura": "",
                "Pomelli_MaterialePerno": "Matériel tige",
                "Pomelli_TrattamentoSuperficialePerno": "",
                "Pomelli_MaterialeBoccola": "Matériel douille",
                "Pomelli_TrattamentoSuperficialeBoccola": "",
                "Pomelli_MaterialeSpina": "Matériel axe",
                "ChiusureLeva_Accessori": "",
                "ChiusureLeva_Note": "Remarques",
                "ChiusureLeva_TrattamentoSuperficiale": "",
                "ChiusureLeva_Materiale": "Matériel",
                "Sollevamento_MaterialeVite": "Matériel vis",
                "Sollevamento_MaterialeCorpo": "Matériel corps",
                "Sollevamento_Certificazioni": "Certification",
                "Sollevamento_TempEsercizio": "Température d’exercice",
                "Sollevamento_Orientabilita": "Orientabilité",
                "Sollevamento_CoefficenteSicurezza": "Coefficient de sécurité",
                "Sollevamento_Impiego": "Utilisation",
                "Sollevamento_Note": "Remarques",
                "Sollevamento_Norma": "Norme",
                "Sollevamento_Test": "Test",
                "Sollevamento_Attenzione": "",
                "Sollevamento_Finitura": "",
                "Sollevamento_Materiale": "Matériel",
                "Magneti_PoloContrassegnato": "Pôle identifié",
                "Magneti_Grado": "Degré",
                "Magneti_TempEsercizio": "Température d’exercice",
                "Magneti_Magnetizzazione": "Aimantation",
                "Magneti_Note": "Remarques",
                "Magneti_TrattamentoSuperficiale": "",
                "Magneti_Materiale": "Matériel",
                "Magneti_MaterialeMagnete": "Matériel aimant",
                "Magneti_MaterialeRivestimento": "Matériel revêtement",
                "Magneti_TrattamentoSuperficialeMagnete": "",
                "Magneti_MaterialeEspansore": "Matériel expanseur",
                "Magneti_MaterialeCorpo": "Matériel corps",
                "Magneti_TrattamentoSuperficialeCorpo": "",
                "ElemMeccanici_Accessori": "Accessoires",
                "ElemMeccanici_Note": "Remarques",
                "ElemMeccanici_Impiego": "Utilisation",
                "ElemMeccanici_Accoppiamento": "Accouplement",
                "ElemMeccanici_Norma": "Norme",
                "ElemMeccanici_TrattamentoSuperficiale": "",
                "ElemMeccanici_MaterialeCorpo": "Matériel corps",
                "ElemMeccanici_TrattamentoSuperficialeCorpo": "",
                "ElemMeccanici_MaterialeBoccola": "Matériel douille",
                "ElemMeccanici_Materiale": "Matériel",
                "ElemMeccanici_MaterialeMolla": "",
                "ElemMeccanici_MaterialeSfera": "Matériel sphère",
                "ElemMeccanici_MaterialeCorpoMaschio": "Matériel corps mâle",
                "ElemMeccanici_MaterialeCorpoFemmina": "Matériel corps femelle",
                "ElemMeccanici_MaterialeInternoMolla": "Matériel ressort interne",
                "ElemMeccanici_MaterialeEsternoMolla": "Matériel ressort externe",
                "TappiPlastica_TempEsercizio": "Température d’exercice",
                "TappiPlastica_Colore": "Couleur",
                "TappiPlastica_Note": "Remarques",
                "TappiPlastica_MaterialeOring": "Matériel O-ring",
                "TappiPlastica_MaterialeCorpo": "Matériel corps",
                "TappiPlastica_Materiale": "Matériel",
                "TappiPlastica_MaterialeDadi": "Matériau de l'écrou",
                "ElemPosiz_Colore": "",
                "ElemPosiz_InsertoLongLok": "",
                "ElemPosiz_MarcaturaBloccaggio": "Marquage de blocage",
                "ElemPosiz_Accessori": "Accessoires",
                "ElemPosiz_Note": "Remarques",
                "ElemPosiz_TrattamentoSuperficiale": "",
                "ElemPosiz_Materiale": "Matériel",
                "ElemPosiz_MaterialeCorpo": "Matériel corps",
                "ElemPosiz_MaterialeImpugnatura": "Matériel manette",
                "ElemPosiz_MaterialePerno": "Matériel tige",
                "ElemPosiz_MaterialePulsante": "Matériel bouton",
                "ElemPosiz_MaterialeMolla": "Matériel ressort",
                "ElemPosiz_MaterialePuntale": "Matériel téton",
                "ElemPosiz_MaterialePernoBloccaggio": "Matériel goupille de centrage",
                "ElemPosiz_MaterialeAnello": "Matériel anneau",
                "ElemPosiz_MaterialeManopola": "",
                "ElemPosiz_MaterialeSfera": "Matériel sphère",
                "ElemPosiz_MaterialeMolle": "Matériel ressorts",
                "ElemPosiz_MaterialeSfere": "Matériel sphère",
                "ElemPosiz_MaterialeOcchiello": "Matériel anneau",
                "ElemPosiz_MaterialeCavoSpirale": "Matériel câble en spirale",
                "ElemPosiz_MaterialeCavo": "",
                "ElemPosiz_MaterialeCavetto": "Matériel corde",
                "ElemPosiz_MaterialeMorsetto": "Matériel cosse",
                "ElemPosiz_MaterialeCapocorda": "Matériel pince",
                "FissaggiPressione_TempEsercizio": "Température d’exercice",
                "FissaggiPressione_Impiego": "Utilisation",
                "FissaggiPressione_Autoestinguenza": "Autoextinguibilité",
                "FisaggiPressione_Codice": "",
                "FissaggiPressione_Colore": "",
                "FissaggiPressione_Materiale": "Matériel",
                "Distanziatori_Adesivo": "Adhésif",
                "Distanziatori_Note": "Remarques",
                "Distanziatori_Autoestinguenza": "Autoextinguibilité",
                "Distanziatori_TempEsercizio": "Température d’exercice",
                "Distanziatori_Colore": "",
                "Distanziatori_Impiego": "Utilisation",
                "Distanziatori_TrattamentoSuperficiale": "",
                "Distanziatori_Materiale": "Matériel",
                "Molle_Colore": "",
                "Molle_Note": "Remarques",
                "Molle_Materiale": "Matériel",
                "Molle_TrattamentoSuperficiale": "",
                "TerminaliElettrici_ProfiloCrimpatura": "Profil de sertissage",
                "TerminaliElettrici_Materiale": "Matériel",
                "TerminaliElettrici_Corpo": "Matériel corps",
                "TerminaliElettrici_Morsetto": "Matériel structure interne",
                "TerminaliElettrici_Vite": "Matériel vis",
                "TerminaliElettrici_Isolamento": "Isolation",
                "TerminaliElettrici_TensioneNominale": "Tension nominale",
                "TerminaliElettrici_TempEsercizio": "Température d’exercice",
                "TerminaliElettrici_Autoestinguenza": "Autoextinguibilité",
                "TerminaliElettrici_Accessori": "Accessoires",
                "TerminaliElettrici_Note": "Remarques",
                "TerminaliElettrici_Impiego": "Utilisation",
                "TerminaliElettrici_UlCsaFile": "Ul/Csa-File",
                "materialScrewClass": "Matériel / Classe vis",
                "materialNutClass": "Matériel / Classe Écrou",
                "washerHardness": "Dureté rondelle"
            }
        },
        "password_page": {
            "login_form_heading": "Accéder à la boutique à l'aide d'un mot de passe :",
            "login_password_button": "Saisir avec un mot de passe",
            "login_form_password_label": "Mot de passe",
            "login_form_password_placeholder": "Votre mot de passe",
            "login_form_error": "Mot de passe incorrect !",
            "login_form_submit": "Saisir",
            "admin_link_html": "La boutique vous appartient-elle ? <a href=\"/admin\" class=\"link underlined-link\">Se connecter ici</a>",
            "powered_by_shopify_html": "Cette boutique sera propulsée par {{ shopify }}"
        },
        "social": {
            "alt_text": {
                "share_on_facebook": "Partager sur Facebook",
                "share_on_twitter": "Tweeter sur Twitter",
                "share_on_pinterest": "Épingler sur Pinterest"
            },
            "links": {
                "twitter": "Twitter",
                "facebook": "Facebook",
                "pinterest": "Pinterest",
                "instagram": "Instagram",
                "tumblr": "Tumblr",
                "snapchat": "Snapchat",
                "youtube": "YouTube",
                "vimeo": "Vimeo",
                "tiktok": "TikTok"
            }
        },
        "continue_shopping": "Continuer les achats",
        "pagination": {
            "label": "Pagination",
            "page": "Page {{ number }}",
            "next": "Page suivante",
            "previous": "Page précédente"
        },
        "search": {
            "search": "Recherche",
            "reset": "Effacer le terme de recherche",
            "search_code": "Recherche par code article...",
            "search_generic": "Près...",
            "custom_search_title": "Recherche",
            "art_code": "Code article",
            "art_name": "Nom de l'article"
        },
        "cart": {
            "view": "Voir le panier ({{ count }})",
            "item_added": "Article ajouté au panier",
            "view_empty_cart": "Voir le panier"
        },
        "share": {
            "copy_to_clipboard": "Copier le lien",
            "share_url": "Lien",
            "success_message": "Lien copié dans le presse-papiers",
            "close": "Fermer le partage"
        },
        "slider": {
            "of": "de",
            "next_slide": "Faire glisser vers la droite",
            "previous_slide": "Faire glisser vers la gauche",
            "name": "Carrousel"
        },
        "br-pagination": {
            "label": "TODO",
            "page": "TODO",
            "next": "TODO",
            "previous": "TODO"
        }
    },
    "newsletter": {
        "label": "E-mail",
        "success": "Merci de votre inscription",
        "button_label": "S'inscrire"
    },
    "accessibility": {
        "skip_to_text": "Ignorer et passer au contenu",
        "close": "Fermer",
        "unit_price_separator": "par",
        "vendor": "Fournisseur :",
        "error": "Erreur",
        "refresh_page": "Le choix d'une sélection entraîne l'actualisation de la page entière.",
        "link_messages": {
            "new_window": "S'ouvre dans une nouvelle fenêtre.",
            "external": "Ouvre un site web externe."
        },
        "loading": "Chargement en cours...",
        "skip_to_product_info": "Passer aux informations produits",
        "total_reviews": "total des critiques",
        "star_reviews_info": "{{ rating_value }} sur {{ rating_max }} étoiles",
        "collapsible_content_title": "Contenu réductible",
        "complementary_products": "Produits complémentaires"
    },
    "blogs": {
        "article": {
            "blog": "Blog",
            "read_more_title": "Lire la suite : {{ title }}",
            "comments": {
                "one": "{{ count }} commentaire",
                "other": "{{ count }} commentaires",
                "many": "{{ count }} commentaires"
            },
            "moderated": "Veuillez noter que les commentaires doivent être approuvés avant d'être publiés.",
            "comment_form_title": "Laisser un commentaire",
            "name": "Nom",
            "email": "E-mail",
            "message": "Commentaire",
            "post": "Publier le commentaire",
            "back_to_blog": "Retour au blog",
            "share": "Partager cet article",
            "success": "Votre commentaire a bien été publié ! Merci !",
            "success_moderated": "Votre commentaire a bien été publié. Nous le publierons sous peu, conformément au processus de modération de notre blog."
        }
    },
    "onboarding": {
        "product_title": "Titre du produit",
        "collection_title": "Le nom de votre collection"
    },
    "products": {
        "product": {
            "add_to_cart": "Ajouter au panier",
            "description": "Description",
            "on_sale": "En vente",
            "product_variants": "Variantes de produits",
            "variants_title": "Variantes de produits",
            "variants_subtitle": "affichez le panier pour commander ou demander un nouveau devis.",
            "quantity": {
                "label": "Quantité",
                "input_label": "Quantité pour {{ product }}",
                "increase": "Augmenter la quantité de {{ product }}",
                "decrease": "Réduire la quantité de {{ product }}",
                "minimum_of": "Minimum de {{ quantity }}",
                "maximum_of": "Maximum de {{ quantity }}",
                "multiples_of": "Incréments de {{ quantity }}",
                "in_cart_html": "<span class=\"quantity-cart\">{{ quantity }}</span> dans le panier",
                "note": "Voir les règles de quantité"
            },
            "price": {
                "from_price_html": "Du {{ price }}",
                "regular_price": "Prix habituel",
                "sale_price": "Prix promotionnel",
                "unit_price": "Prix unitaire"
            },
            "share": "Partager ce produit",
            "sold_out": "Épuisé",
            "unavailable": "Non disponible",
            "vendor": "Fournisseur",
            "video_exit_message": "{{ title }} ouvre la vidéo en plein écran dans la même fenêtre.",
            "xr_button": "Afficher dans son espace",
            "xr_button_label": "Affichage dans votre espace, charge l'article dans une fenêtre de réalité augmentée",
            "pickup_availability": {
                "view_store_info": "Afficher les informations de la boutique",
                "check_other_stores": "Vérifier la disponibilité dans d'autres boutiques",
                "pick_up_available": "Service de retrait disponible",
                "pick_up_available_at_html": "Service de retrait disponible à <span class=\"color-foreground\">{{ location_name }}</span>",
                "pick_up_unavailable_at_html": "Service de retrait non disponible actuellement à <span class=\"color-foreground\">{{ location_name }}</span>",
                "unavailable": "Impossible de charger la disponibilité du service de retrait",
                "refresh": "Actualiser"
            },
            "media": {
                "open_media": "Ouvrir le média {{ index }} dans une fenêtre modale",
                "play_model": "Lire la visionneuse 3D",
                "play_video": "Lire la vidéo",
                "gallery_viewer": "Visionneuse de la galerie",
                "load_image": "Charger l'image {{ index }} dans la galerie",
                "load_model": "Charger le modèle 3D {{ index }} dans la galerie",
                "load_video": "Lire la vidéo {{ index }} dans la galerie",
                "image_available": "L'image {{ index }} est maintenant disponible dans la galerie"
            },
            "view_full_details": "Afficher tous les détails",
            "include_taxes": "Taxes incluses.",
            "shipping_policy_html": "<a href=\"{{ link }}\">Frais d'expédition</a> calculés à l'étape de paiement.",
            "choose_options": "Choisir des options",
            "choose_product_options": "Choisir des options pour {{ product_name }}",
            "value_unavailable": "{{ option_value }} – indisponible",
            "variant_sold_out_or_unavailable": "Variante épuisée ou indisponible",
            "inventory_in_stock": "En stock",
            "inventory_in_stock_show_count": "{{ quantity }} en stock",
            "inventory_low_stock": "Stock bas",
            "inventory_low_stock_show_count": "Stock bas : {{ quantity }} restant(s)",
            "sku": "SKU",
            "inventory_out_of_stock": "En rupture de stock",
            "inventory_out_of_stock_continue_selling": "En stock",
            "volume_pricing": {
                "title": "Tarification basée sur le volume",
                "note": "La tarification basée sur le volume est disponible",
                "minimum": "{{ quantity }} ou plus",
                "price_at_each": "à {{ price }}/pièce",
                "price_range": "{{ minimum }} - {{ maximum }}"
            },
            "tech_sheet_download": "Téléchargez fiche technique",
            "compliance_sheet_download": "Téléchargez certificat de conformité",
            "all_variants": "TODO",
            "login_to_see_prices": "Connectez-vous pour voir les prix.",
            "login_to_quote_html": "<a href='/fr/account/login'>Connectez-vous</a> à votre espace réservé ou inscrivez-vous pour demander un devis.",
            "want_to_be_customer": "Vous souhaitez devenir notre client?",
            "sign_up_to_buy_html": "<a href='/fr/account/register'>Inscrivez-vous</a>, remplissez le panier et demandez un devis. Nous lancerons le processus d’affiliation.",
            "want_to_quote": "Vous souhaitez passer une commande ou demander un devis ?",
            "in_the_cart": "Dans le panier, vous pouvez commander les articles sélectionnés ou demander un devis.",
            "certifications": "Certifications",
            "regulations": "TODO",
            "life_cycle": "TODO",
            "additional_tab": "TODO",
            "additional_infos": {
                "ElemPosiz_Colore": "TODO",
                "ElemPosiz_InsertoLongLok": "TODO"
            }
        },
        "modal": {
            "label": "Galerie de supports multimédias"
        },
        "facets": {
            "apply": "Appliquer",
            "clear": "Effacer",
            "clear_all": "Tout supprimer",
            "from": "De",
            "filter_and_sort": "Filtrer et trier",
            "filter_by_label": "Filtre :",
            "filter_button": "Filtrer",
            "filters_selected": {
                "one": "{{ count }} sélectionné",
                "other": "{{ count }} sélectionnés",
                "many": "{{ count }} sélectionnés"
            },
            "max_price": "Le prix le plus élevé est de {{ price }}",
            "product_count": {
                "one": "{{ product_count }} produit sur {{ count }}",
                "other": "{{ product_count }} produits sur {{ count }}",
                "many": "{{ product_count }} produits sur {{ count }}"
            },
            "product_count_simple": {
                "one": "{{ count }} produit",
                "other": "{{ count }} produits",
                "many": "{{ count }} produits"
            },
            "reset": "Réinitialiser",
            "sort_button": "Trier",
            "sort_by_label": "Trier par :",
            "to": "À",
            "clear_filter": "Supprimer le filtre",
            "filter_selected_accessibility": "{{ type }} ({{ count }} filtres sélectionnés)",
            "show_more": "Afficher plus",
            "show_less": "Afficher moins",
            "filter_and_operator_subtitle": "Tout associer"
        }
    },
    "templates": {
        "404": {
            "title": "Page non trouvée",
            "subtext": "404"
        },
        "search": {
            "no_results": "Aucun résultat trouvé pour « {{ terms }} ». Vérifiez l'orthographe ou utilisez un autre mot ou une autre expression.",
            "results_with_count": {
                "one": "{{ count }} résultat",
                "other": "{{ count }} résultats",
                "many": "{{ count }} résultats"
            },
            "title": "Résultats de la recherche",
            "page": "Page",
            "products": "Produits",
            "search_for": "Rechercher « {{ terms }} »",
            "results_with_count_and_term": {
                "one": "{{ count }} résultat trouvé pour « {{ terms }} »",
                "other": "{{ count }} résultats trouvés pour « {{ terms }} »",
                "many": "{{ count }} résultats trouvés pour « {{ terms }} »"
            },
            "results_pages_with_count": {
                "one": "Page {{ count }}",
                "other": "Pages {{ count }}",
                "many": "Pages {{ count }}"
            },
            "results_suggestions_with_count": {
                "one": "{{ count }} suggestion",
                "other": "{{ count }} suggestions",
                "many": "{{ count }} suggestions"
            },
            "results_products_with_count": {
                "one": "Produit {{ count }}",
                "other": "Produits {{ count }}",
                "many": "Produits {{ count }}"
            },
            "suggestions": "Suggestions",
            "pages": "Pages"
        },
        "cart": {
            "cart": "Panier"
        },
        "contact": {
            "form": {
                "name": "Nom",
                "email": "E-mail",
                "phone": "Numéro de téléphone",
                "comment": "Commentaire",
                "send": "Envoyer",
                "post_success": "Merci de nous avoir contactés. Nous vous répondrons dès que possible.",
                "error_heading": "Veuillez ajuster les éléments suivants :",
                "title": "Formulaire de contact"
            }
        },
        "work_with_us": {
            "form": {
                "first_name": "TODO",
                "last_name": "TODO",
                "email": "TODO",
                "presentation": "TODO",
                "terms": {
                    "name": "TODO",
                    "first_text": "TODO",
                    "link_text": "TODO",
                    "last_text": "TODO"
                },
                "cv": {
                    "label": "TODO",
                    "select_file": "TODO",
                    "no_files_uploaded": "TODO",
                    "upload": "TODO",
                    "name": "TODO"
                },
                "send": "TODO",
                "phone": "Numéro de téléphone",
                "comment": "FAIRE"
            }
        }
    },
    "sections": {
        "header": {
            "announcement": "Annonce",
            "menu": "Menu",
            "cart_count": {
                "one": "{{ count }} article",
                "other": "{{ count }} articles",
                "many": "{{ count }} articles"
            }
        },
        "cart": {
            "title": "Votre panier",
            "caption": "Articles du panier",
            "remove_title": "Supprimer {{ title }}",
            "note": "Instructions spéciales concernant la commande",
            "checkout": "Procéder au paiement",
            "empty": "Votre panier est vide",
            "cart_error": "Une erreur est survenue lors de l’actualisation de votre panier. Veuillez réessayer.",
            "cart_quantity_error_html": "Vous ne pouvez pas ajouter plus de {{ quantity }} de ce produit à votre panier.",
            "taxes_and_shipping_policy_at_checkout_html": "Taxes, réductions et <a href=\"{{ link }}\">frais d’expédition</a> calculés à l’étape du paiement",
            "taxes_included_but_shipping_at_checkout": "Taxe incluse, frais d’expédition et réductions calculés à l’étape du paiement",
            "taxes_included_and_shipping_policy_html": "Taxe incluse. <a href=\"{{ link }}\">Frais d’expédition</a> et réductions calculés à l’étape du paiement.",
            "taxes_and_shipping_at_checkout": "Taxes, réductions et frais d’expédition calculés à l’étape du paiement",
            "headings": {
                "product": "Produit",
                "price": "Prix",
                "total": "Total",
                "quantity": "Quantité",
                "image": "Image de produit"
            },
            "update": "Mettre à jour",
            "login": {
                "title": "Vous possédez un compte ?",
                "paragraph_html": "<a href=\"{{ link }}\" class=\"link underlined-link\">Connectez-vous</a> pour payer plus vite."
            },
            "estimated_total": "Total estimé",
            "new_estimated_total": "Nouveau total estimé"
        },
        "footer": {
            "payment": "Moyens de paiement"
        },
        "featured_blog": {
            "view_all": "Tout afficher",
            "onboarding_title": "Article de blog",
            "onboarding_content": "Donnez à vos clients un résumé de votre article de blog"
        },
        "featured_collection": {
            "view_all": "Tout afficher",
            "view_all_label": "Afficher tous les produits de la collection {{ collection_name }}"
        },
        "collection_list": {
            "view_all": "Tout afficher"
        },
        "collection_template": {
            "title": "Collection",
            "empty": "Aucun produit trouvé",
            "use_fewer_filters_html": "Utiliser moins de filtres ou <a class=\"{{ class }}\" href=\"{{ link }}\">tout supprimer</a>"
        },
        "video": {
            "load_video": "Charger la vidéo : {{ description }}"
        },
        "slideshow": {
            "load_slide": "Charger la diapositive",
            "previous_slideshow": "Diapositive précédente",
            "next_slideshow": "Diapositive suivante",
            "pause_slideshow": "Interrompre le diaporama",
            "play_slideshow": "Lire le diaporama",
            "carousel": "Carrousel",
            "slide": "Diapositive"
        },
        "page": {
            "title": "Titre de la page"
        },
        "announcements": {
            "previous_announcement": "Annonce précédente",
            "next_announcement": "Annonce suivante",
            "carousel": "Carrousel",
            "announcement": "Annonce",
            "announcement_bar": "Barre d’annonces"
        },
        "quick_order_list": {
            "product_total": "Sous-total des produits",
            "view_cart": "Voir le panier",
            "each": "{{ money }}/pièce",
            "product": "Produit",
            "variant": "Variante",
            "variant_total": "Total des variantes",
            "items_added": {
                "one": "{{ quantity }} article ajouté",
                "other": "{{ quantity }} articles ajoutés",
                "many": "{{ quantity }} articles ajoutés"
            },
            "items_removed": {
                "one": "{{ quantity }} article retiré",
                "other": "{{ quantity }} articles retirés",
                "many": "{{ quantity }} articles retirés"
            },
            "product_variants": "Variantes de produits",
            "total_items": "Total des articles",
            "remove_all_items_confirmation": "Retirer les {{ quantity }} articles de votre panier ?",
            "remove_all": "Tout retirer",
            "cancel": "Annuler"
        }
    },
    "localization": {
        "country_label": "Pays/région",
        "language_label": "Langue",
        "update_language": "Mettre à jour la langue",
        "update_country": "Mettre à jour le pays/la région"
    },
    "customer": {
        "account": {
            "title": "Compte",
            "details": "Détails du compte",
            "view_addresses": "Voir les adresses",
            "return": "Retour aux détails du compte"
        },
        "account_fallback": "Compte",
        "activate_account": {
            "title": "Activer le compte",
            "subtext": "Créez votre mot de passe pour activer le compte.",
            "password": "Mot de passe",
            "password_confirm": "Confirmer le mot de passe",
            "submit": "Activer le compte",
            "cancel": "Décliner l'invitation"
        },
        "addresses": {
            "title": "Adresses",
            "default": "Par défaut",
            "add_new": "Ajouter une nouvelle adresse",
            "edit_address": "Modifier l'adresse",
            "first_name": "Prénom",
            "last_name": "Nom de famille",
            "company": "Entreprise",
            "address1": "Adresse 1",
            "address2": "Adresse 2",
            "city": "Ville",
            "country": "Pays/région",
            "province": "Province",
            "zip": "Code postal",
            "phone": "Téléphone",
            "set_default": "Définir comme adresse par défaut",
            "add": "Ajouter l'adresse",
            "update": "Mettre à jour l'adresse",
            "cancel": "Annuler",
            "edit": "Modifier",
            "delete": "Supprimer",
            "delete_confirm": "Êtes-vous certain(e) de vouloir supprimer cette adresse ?"
        },
        "log_in": "Connexion",
        "log_out": "Déconnexion",
        "login_page": {
            "cancel": "Annuler",
            "create_account": "Créer un compte",
            "email": "E-mail",
            "forgot_password": "Mot de passe oublié ?",
            "guest_continue": "Continuer",
            "guest_title": "Continuer en tant qu'invité(e)",
            "password": "Mot de passe",
            "title": "Connexion",
            "sign_in": "Connexion",
            "submit": "Envoyer",
            "send_edit_password_title": "Envoyer une demande de modification",
            "send_edit_password_subtitle": "Nous vous enverrons un email avec le lien de modification."
        },
        "orders": {
            "title": "Historique des commandes",
            "order_number": "Commande",
            "order_number_link": "Numéro de commande {{ number }}",
            "date": "Date",
            "payment_status": "Statut des paiements",
            "fulfillment_status": "Statut des commandes",
            "total": "Total",
            "none": "Vous n'avez encore passé aucune commande."
        },
        "recover_password": {
            "title": "Réinitialiser son mot de passe",
            "subtext": "Nous vous ferons parvenir un e-mail pour réinitialiser votre mot de passe",
            "success": "Nous vous avons envoyé un e-mail contenant un lien pour mettre à jour votre mot de passe."
        },
        "register": {
            "title": "Inscrivez-vous pour devenir client",
            "subtitle": "Registrati per accedere alla tua area riservata. Potrai avere accesso al listino prezzi dei nostri prodotti, effettuare gli ordini e richiedere preventivi per il tuo punto vendita.",
            "has_account": "Hai già un account?",
            "login": "Accedi",
            "submit": "Créer",
            "create_account": {
                "title": "Créer un compte",
                "email": "Email",
                "password": "Mot de passe",
                "password_confirm": "confirmer le mot de passe"
            },
            "personal_info": {
                "title": "Informations personnelles",
                "first_name": "Prénom",
                "last_name": "Nom de famille",
                "role": "rôle",
                "phone": "téléphone"
            },
            "company": {
                "title": "Entreprise",
                "company_name": "nom de l'entreprise",
                "vat_number": "numéro de TVA",
                "business_sector": "Secteur d'activité",
                "employees_number": "Nombre d'employés",
                "phone": "téléphone",
                "address": "Adresse",
                "civic_address": "Adresse civique",
                "nation": "Nation",
                "province": "Province",
                "postal_code": "Code Postal",
                "city": "Ville"
            }
        },
        "reset_password": {
            "title": "Réinitialiser le mot de passe du compte",
            "subtext": "Saisissez un nouveau mot de passe",
            "password": "Mot de passe",
            "password_confirm": "Confirmer le mot de passe",
            "submit": "Réinitialiser le mot de passe"
        },
        "order": {
            "title": "Commande {{ name }}",
            "date_html": "Passée le {{ date }}",
            "cancelled_html": "Commande annulée le {{ date }}",
            "cancelled_reason": "Motif : {{ reason }}",
            "billing_address": "Adresse de facturation",
            "payment_status": "Statut de paiement",
            "shipping_address": "Adresse d'expédition",
            "fulfillment_status": "Statut des commandes",
            "discount": "Réduction",
            "shipping": "Expédition",
            "tax": "Taxes",
            "product": "Produit",
            "sku": "SKU",
            "price": "Prix",
            "quantity": "Quantité",
            "total": "Total",
            "fulfilled_at_html": "Traitée le {{ date }}",
            "track_shipment": "Suivre l'envoi",
            "tracking_url": "Lien de suivi",
            "tracking_company": "Transporteur",
            "tracking_number": "Numéro de suivi",
            "subtotal": "Sous-total",
            "total_duties": "Frais de douane",
            "total_refunded": "Remboursé"
        }
    },
    "gift_cards": {
        "issued": {
            "title": "Voici le solde de votre carte‑cadeau {{ shop }} d'une valeur de {{ value }} !",
            "subtext": "Votre carte-cadeau",
            "gift_card_code": "Code de la carte-cadeau",
            "shop_link": "Visiter la boutique en ligne",
            "add_to_apple_wallet": "Ajouter à Apple Wallet",
            "qr_image_alt": "Code QR : scannez-le pour utiliser votre carte-cadeau",
            "copy_code": "Copier le code de la carte‑cadeau",
            "expired": "Expiré",
            "copy_code_success": "Le code a bien été copié",
            "how_to_use_gift_card": "Utiliser le code de la carte‑cadeau en ligne ou le code QR en boutique",
            "expiration_date": "Expire le {{ expires_on }}"
        }
    },
    "recipient": {
        "form": {
            "checkbox": "Je veux envoyer ce produit comme cadeau",
            "email_label": "E‑mail du destinataire",
            "email": "E‑mail",
            "name_label": "Nom du destinataire (facultatif)",
            "name": "Nom",
            "message_label": "Message (facultatif)",
            "message": "Message",
            "max_characters": "{{ max_chars }} caractères au maximum",
            "email_label_optional_for_no_js_behavior": "E‑mail du destinataire (facultatif)",
            "send_on": "AAAA-MM-JJ",
            "send_on_label": "Envoyer le (facultatif)",
            "expanded": "Formulaire de destinataire de carte-cadeau agrandi",
            "collapsed": "Formulaire de destinataire de carte-cadeau réduit"
        }
    },
    "select_customer": {
        "customer": "Client",
        "select_customer": "Sélectionnez un client ou un groupe de clients",
        "search_customer": "Rechercher un client par code, nom de client ou groupe...",
        "code": "Code",
        "name": "Nom",
        "customerGroup": "Groupe de clients"
    },
    "berardi": {
        "go_back": "Retourner",
        "csv_importing": "J'importe le CSV sélectionné.",
        "no_close_advice": "Ne fermez pas et ne rechargez pas cette page.",
        "error_csv_importing": "Une erreur s'est produite lors du chargement du CSV.",
        "success_full_csv_importing": "Importation CSV réussie.",
        "success_partial_csv_importing": "L'importation CSV a réussi, mais il y a des erreurs.",
        "reorder_progress": "J'ajoute les produits de la commande sélectionnée au panier.",
        "error_reorder": "Une erreur s'est produite lors de l'ajout au panier.",
        "success_full_reorder": "Ajout au panier réussi.",
        "success_partial_reorder": "L'ajout au panier a réussi, mais il y a des erreurs.",
        "send_order_quote_progress": "Je crée la commande et/ou le devis.",
        "error_send_order_quote": "Une erreur est survenue lors de la création de la commande et/ou du devis.",
        "account": {
            "menu": {
                "general_infos": "Info générales",
                "company": "Société",
                "orders_history": "Historique commandes",
                "quotes_history": "Historique devis",
                "invoices_history": "Historique factures",
                "logout": "Logout"
            },
            "general_infos": {
                "title": "Info générales",
                "account_infos": "Info account",
                "user_name": "Nom d'utilisateur",
                "user_email": "E-mail",
                "user_role": "Fonction",
                "user_mobile": "Portable",
                "change_password": "Modifier le mot de passe",
                "agency_infos": "Info société",
                "customer_code": "Code client",
                "company": "Raison sociale",
                "vat": "Numéro TVA",
                "activity": "Secteur d'activité",
                "workers": "Salariés",
                "phone": "Téléphone",
                "country": "Pays",
                "province": "Région",
                "city": "Localité",
                "zip": "Code postal",
                "address": "Adresse"
            },
            "company": {
                "title": "Société",
                "company": "Raison sociale",
                "customer_code": "Code client",
                "name": "Raison sociale",
                "vat": "Numéro TVA",
                "business": "Secteur d'activité",
                "workers": "Salariés",
                "phone": "Téléphone",
                "country": "Pays",
                "province": "Région",
                "city": "Localité",
                "zip": "Code postal",
                "address": "Adresse",
                "operational_users": "Utilisateurs autorisés",
                "table": {
                    "user_name": "Nom d'utilisateur",
                    "email": "Email",
                    "phone": "Portable"
                },
                "no_companies_found": "Aucun résultat trouvé"
            },
            "orders_history": {
                "title": "Historique commandes",
                "label_select_company": "Voir les commandes de la société:",
                "doc_number": "Numéro document",
                "doc_number_placeholder": "ex. 0046100300300",
                "from": "De",
                "to": "à",
                "search_order": "Cherchez la commande",
                "nothing_found": "Aucune commande trouvée",
                "error_reorder": "Une erreur s'est produite pendant l'opération.",
                "table": {
                    "order": "Commande",
                    "date": "Date",
                    "total": "Total",
                    "order_status": "Statut commande",
                    "reorder": "re-commander",
                    "load_more": "Passer d'autres commandes"
                }
            },
            "quotes_history": {
                "title": "Historique devis",
                "label_select_company": "Voir les devis de la société:",
                "doc_number": "Numéro document",
                "doc_number_placeholder": "ex. 0046100300300",
                "from": "De",
                "to": "à",
                "search_quote": "Cherchez le devis",
                "nothing_found": "Aucun devis trouvé",
                "table": {
                    "quote": "Devis",
                    "date": "Date",
                    "new_offer": "Nouveau devis",
                    "quote_status": "Statut devis",
                    "load_more": "Passer d'autres devis"
                }
            },
            "invoices_history": {
                "title": "Historique factures",
                "label_select_company": "Visualisez situation financière de la société:",
                "expired_invoices": "Factures échues",
                "expiring_invoices": "Factures arrivant à échéance",
                "payment_method": "Type de paiement",
                "billing_address": "Adresse de facturation",
                "nothing_found": "Aucune facture trouvée",
                "table": {
                    "invoice_number": "Numéro facture",
                    "date": "Date émission",
                    "expiring_date": "Date échéance",
                    "payment_method": "Type de paiement",
                    "value": "Montant à payer",
                    "invoice_status": "Statut facture",
                    "currency": "Devise",
                    "download": "Téléchargez",
                    "load_more": "Chargez autres factures",
                    "error_download": "Une erreur s'est produite pendant le téléchargement facture"
                }
            },
            "order_detail": {
                "title": "Commande",
                "go_back": "Arrière",
                "download": "Download",
                "your_reference": "Votre référence",
                "date_order": "Date commande",
                "weight": "Poids en kg",
                "payment": "Paiement",
                "return_terms": "Termes de livraison",
                "billing_address": "Adresse de facturation",
                "shipping_address": "Adresse de livraison",
                "table": {
                    "art_code": "Réf. Article",
                    "art_code_customer": "Réf. Art. client",
                    "description": "Désignation",
                    "measure_unit": "U. m.",
                    "total_quantity": "Qté tot",
                    "unit_price": "Prix un.",
                    "discount_1": "Rem. 1",
                    "discount_2": "Rem. 2",
                    "discount_3": "Rem. 3",
                    "increase": "Majoration",
                    "net_unit_price": "Prix un. net",
                    "net_total": "Montant net",
                    "deliver_date": "Date livraison"
                }
            },
            "quote_detail": {
                "title": "Devis",
                "go_back": "Arrière",
                "download": "Download",
                "your_reference": "Votre référence",
                "date_quote": "Date devis",
                "weight": "Poids en kg",
                "payment": "Paiement",
                "return_terms": "Termes de livraison",
                "billing_address": "Adresse de facturation",
                "shipping_address": "Adresse de livraison",
                "table": {
                    "art_code": "Réf. Article",
                    "art_code_customer": "Réf. Art. client",
                    "description": "Désignation",
                    "measure_unit": "U. m.",
                    "total_quantity": "Qté tot",
                    "unit_price": "Prix un.",
                    "discount_1": "Rem. 1",
                    "discount_2": "Rem. 2",
                    "discount_3": "Rem. 3",
                    "increase": "Majoration",
                    "net_unit_price": "Prix un. net",
                    "net_total": "Montant net",
                    "deliver_date": "Date livraison"
                }
            },
            "document_status_list": {
                "pending": "en cours",
                "delivering": "en consignation",
                "delivered": "livré",
                "processed": "traité",
                "invoiced": "facturé",
                "refused": "refusé",
                "accepted": "accepté",
                "on_customer_approve": "en approbation client",
                "on_offer_progress": "en phase d'offre",
                "canceled": "annulé",
                "expired": "échue",
                "expiring": "arrivant à échéance",
                "paid": "payée",
                "active": "actif",
                "created": "créé",
                "approved": "approuvé",
                "cancelled": "annulé",
                "confirmed": "confirmé"
            },
            "totals_component": {
                "text": "Les conditions générales de fourniture disponibles sur le site www.gberardi.com s'appliquent à tous les contrats de vente par BERARDI BULLONERIE s.r.l. Des conditions contractuelles divergentes, même si elles sont contenues dans des conditions générales ou particulières d'achat rédigées par le client lui-même, ne s'appliquent pas et ne lient BERARDI BULLONERIE s.r.l. que si elles sont expressément acceptées par écrit par ce dernier",
                "products_total": "Numéro articles",
                "discount": "Remise",
                "net_total": "Total net",
                "packaging": "Frais accessoires",
                "shipment": "Transport",
                "order_total": "Total commande"
            }
        },
        "cart": {
            "cart_title": "Mon panier",
            "login_to_receive_quotation": "Connectez-vous ou inscrivez-vous pour demander un devis.",
            "proceed_to_checkout": "Consultez le résumé de la demande.",
            "minimum_order_total": "Minimum de commande 200,00€",
            "code": "Réf. Article",
            "details": "détails",
            "request_quotation": "Demander un devis",
            "request_quotation_text": "Envoyez une demande de devis pour les articles dans le panier d'achat. Vous serez contacté par notre Service Clients.",
            "quote_all": "Demander un devis pour tous les articles",
            "quote": "devis",
            "order_detail": "Détails commande",
            "total_items": "Numéro articles",
            "subtotal": "Sous-total",
            "quantity_discount": "Remise quantité",
            "total_no_vat": "Total hors TVA",
            "vat": "TVA",
            "total": "Total TVA incluse",
            "quote_request": "Demande de devis",
            "pieces": "Pièces",
            "pieces_short": "pcs",
            "quote_request_text": "Le sous-total calculé est provisoire, la demande de devis vise à recalculer le prix dans le cas où la quantité demandée est élevée.",
            "proceed": "Procédez",
            "csv_box_title": "Chargez la liste articles dans le panier",
            "csv_box_text": "Chargez votre fichier .csv avec les réf. articles et les quantités souhaitées.",
            "csv_box_text_instructions": "Insérez vos réf. articles, s'ils sont présents dans notre système, dans la colonne CUSTOMER_CODE",
            "csv_box_no_file": "Aucun fichier .csv chargé",
            "csv_select_file": "Sélectionnez fichier",
            "csv_download": "Download template",
            "csv_upload": "Télécharger",
            "unit_price": "Prix unitaire",
            "error_uploading_csv": "Erreur lors du téléchargement du fichier CSV.",
            "summary": {
                "title": "Récapitulatif",
                "subtitle": "Envoyez la demande à notre service client. Vous pourrez toujours vérifier l'état de la demande dans votre espace personnel.",
                "order_summary": "Récapitulatif commande",
                "addresses": "Adresses",
                "billing_address": "Adresse de facturation",
                "shipping_address": "Adresse de livraison",
                "additional_info": "Informations supplémentaires",
                "your_reference": "Votre référence",
                "input_reference": "Insérez la référence",
                "note": "Note",
                "input_note": "Ajoutez une note",
                "order_items": "Articles commande",
                "items_total": "Tot. articles",
                "discount": "Remise",
                "order_total": "Total commande",
                "order_total_quote": "Demande de devis",
                "quote_summary": "Récapitulatif devis",
                "input_note_quote": "Ajoutez une note au devis",
                "quote_items": "Articles devis",
                "disclaimer": "Les conditions générales de fourniture disponibles sur www.gberardi.com s'appliquent à tous les contrats de vente conclus par BERARDI BULLONERIE s.r.l. Des conditions contractuelles différentes, même si elles sont contenues dans des conditions générales ou particulières d'achat préparées par le client, ne sont pas applicables et ne lient pas BERARDI BULLONERIE s.r.l. sauf si elles sont expressément et par écrit acceptées par cette dernière.",
                "send": "Envoyer",
                "error_send_order_quote": "Une erreur s'est produite lors de l'envoi de la commande."
            },
            "thank_you": {
                "thank_you_title": "Merci de nous avoir choisi!",
                "for_more_info": "Nous avons bien reçu votre demande. Vous pourrez suivre l’avancement de la demande dans votre espace personnel.",
                "back_to_home": "Retour à l'accueil",
                "order_title": "Commande",
                "order_title_failed": "Commande envoyée",
                "order_not_success": "Votre commande nécessite une vérification par un de nos opérateurs. Dès que la vérification sera terminée, vous trouverez votre commande dans la section Historique des commandes.",
                "order_success": "La commande a été envoyée avec succès. Vous pourrez bientôt suivre l’état dans votre espace personnel.",
                "items_number": "Numéro article",
                "quote_title": "Demande de devis envoyée",
                "quote_success": "Dans les prochaines heures, vous recevrez un devis de la part de notre opérateur.",
                "quote_not_success": "Votre devis nécessite une vérification de notre part, dès que celle-ci sera terminée, vous recevrez le devis de notre opérateur"
            }
        },
        "product": {
            "buttons": {
                "tech_sheet_download": "Téléchargez fiche technique",
                "compliance_sheet_download": "Téléchargez certificat de conformité"
            },
            "table_data": {
                "code": "Référence",
                "color": "Couleur",
                "brand": "Brand",
                "material": "Matière"
            },
            "filters": {
                "sku": "Référence"
            },
            "table": {
                "art_code": "Réf. Art",
                "art_code_customer": "Réf. Art. Client",
                "weight": "Poids",
                "pieces_per_package": "Pcs boite",
                "unit_price": "Prix unitaire",
                "total_price": "Prix total",
                "number_of_pieces": "Numéro pièces",
                "availability": "Disponibilité",
                "associate": "Associez",
                "login_to_see_price": "Connectez-vous pour voir le prix",
                "pieces": "Pièces",
                "details": "détails",
                "insufficient_qty": "Partiel. disponible",
                "not_available": "Non disponible",
                "available": "Disponible",
                "load_more_variants": "Ajouter autres variantes",
                "added_product": "Article ajouté au panier: ",
                "filter_label": "Filtrer par",
                "carico_max_dan": "Charge max (daN)",
                "diam_albero": "Ø arbre",
                "portata_in_kg": "Capacité (kg)",
                "dndeg_fil_x_pollice": "d/fil. x pouce"
            },
            "clothing_selector": {
                "color": "Couleur",
                "size": "Taille",
                "unit_price": "Prix unitaire",
                "pieces_number": "Numéro pièces",
                "total_price": "Prix total",
                "add_to_cart": "Ajouter au panier",
                "insufficient_qty": "Partiel. disponible",
                "not_available": "Non disponible",
                "available": "Disponible"
            }
        },
        "modals": {
            "general": {
                "confirm": "Confirmez",
                "cancel": "Annulez"
            },
            "associate_id": {
                "title": "Référence article client",
                "paragraph": "Tapez votre code client à associer à l'article.",
                "customer_code": "Réf. Art. Client",
                "placeholder": "Tapez numéro client",
                "warning_text": "Attention! Champ modifiable une seule fois!",
                "explanation_confirm": "Vérifiez que le code client est correct et confirmez l'association. Il ne peut pas être changé par la suite en autonomie. Pour modifier le code, vous devrez contacter le service clientèle de Berardi Bullonerie s.r.l.",
                "associate_button": "Associez"
            }
        },
        "search": {
            "search_code": "Recherchez par référence...",
            "cod_art": "Réf. article",
            "name_art": "Désignation article",
            "no_product_found": "Aucun article trouvé",
            "no_query": "Tapez dans la barre de recherche et appuyez sur Entrée afin de recevoir les résultats"
        },
        "general": {
            "login": "Connectez-vous",
            "sign_up": "Inscrivez-vous",
            "select": "Sélectionnez"
        }
    }
}
